import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="tech-grid bg-blue-950 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-237" data-mp="3bhlk95796all">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-238" data-mp="36j0jn4o39owm">
        <span className="silver-metal inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-blue-950" data-id="element-239" data-mp="31kgxb35l2b3q">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="2wspg3j8bhhq9" /> El sistema más completo de energía nuclear para el
          aula de habla hispana
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-241" data-mp="2nu3okykvasdc">
          Megapack Energía Nuclear Listo
        </h2>
        <p className="mt-3 font-semibold text-slate-300" data-id="element-242" data-mp="2dveie32c2wcx">
          {totalVolumes} tomos · {totalBonuses} bonos estratégicos · Todo listo para usar desde hoy.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-243" data-mp="13x50i5gwjtbp">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-slate-300/20 bg-blue-900 p-4 text-sm font-semibold text-slate-100" data-id="element-244" data-mp="u1acsvxtn822">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-245" data-mp="1crs02kzvxbg1" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-slate-300/50 bg-blue-900 p-6 text-left text-lg font-bold leading-relaxed text-white" data-id="element-246" data-mp="1horxk7io55vj">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-slate-300" aria-hidden="true" data-id="element-247" data-mp="6c8xcoqkmwna" />
          Es un sistema para que entres al aula con confianza y dictes clases que de verdad enseñen cómo funciona la
          energía nuclear y cómo responder a las preguntas que tus alumnos tienen.
        </p>
      </div>
    </section>;
}